/**
 * Offer stamp animation
 * gets the data-stamp attr and duplicates it to create the shadow under the animation
 */
if ($('#offerStamp').length) {
    const thisElement = $('#offerStamp');
    const offerText = thisElement.html();
    thisElement.append('<span class="offer-stamp__text">' + offerText + '</span>')
}

if ($('.topSection__img').length) {
    //- Gets product image height and saves it as CSS variable
    function topSectionProductHeight() {
        document.documentElement.style.setProperty('--topSectionProductHeight', "".concat($('.topSection__img').outerHeight(), "px"));
    };

    window.addEventListener('resize', topSectionProductHeight);
    topSectionProductHeight();
}